<app-spinner-service></app-spinner-service>

<form [formGroup]="lancamentoForm" (ngSubmit)="onSubmit()" class="form-grid">
  <p-steps [model]="steps" [activeIndex]="activeIndex" class="mb-4" [readonly]="false"></p-steps>

  <div *ngIf="activeIndex === 0" class="form-block">
    <fieldset class="form-fieldset">
      <legend class="form-block-legend">
        <i class="pi pi-credit-card"></i>
        Tipo de Lançamento
      </legend>
      
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12">
          <div class="radio-group">
            <div class="radio-option">
              <p-radioButton name="tipo" [value]="0" formControlName="tipo" inputId="recebimento"></p-radioButton>
              <label for="recebimento" class="radio-label">
                <i class="pi pi-arrow-down" style="color: #28a745;"></i>
                Recebimento
              </label>
            </div>
            
            <div class="radio-option">
              <p-radioButton name="tipo" [value]="1" formControlName="tipo" inputId="pagamento"></p-radioButton>
              <label for="pagamento" class="radio-label">
                <i class="pi pi-arrow-up" style="color: #dc3545;"></i>
                Pagamento
              </label>
            </div>
          </div>
          
          <small *ngIf="lancamentoForm.get('tipo')?.invalid && lancamentoForm.get('tipo')?.touched" class="error-message">
            <i class="pi pi-exclamation-triangle"></i>
            Selecione um tipo de lançamento.
          </small>
        </div>
      </div>
    </fieldset>

    <div class="form-actions">
      <p-button label="Avançar" icon="pi pi-arrow-right" (click)="nextStep()"
        [disabled]="lancamentoForm.get('tipo')?.invalid" class="p-button-primary"></p-button>
    </div>
  </div>

  <div *ngIf="activeIndex === 1" class="form-block">
    <fieldset class="form-fieldset">
      <legend class="form-block-legend">
        <i class="pi pi-file-edit"></i>
        Detalhes do Lançamento
      </legend>
      
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-6">
          <label for="periodo">
            Data <span class="required">*</span>
          </label>
          <p-calendar 
            id="periodo" 
            formControlName="periodo" 
            dateFormat="dd/mm/yy"
            [minDate]="dataCriacaoUsuario"
            [showIcon]="true"
            [ngClass]="{'invalid-field': lancamentoForm.get('periodo')?.invalid && lancamentoForm.get('periodo')?.touched}"
            placeholder="Selecione a data">
          </p-calendar>
          <small *ngIf="lancamentoForm.get('periodo')?.invalid && lancamentoForm.get('periodo')?.touched" class="error-message">
            <i class="pi pi-exclamation-triangle"></i>
            Data é obrigatória.
          </small>
          <small class="field-hint">
            <i class="pi pi-info-circle"></i>
            Selecione a data do lançamento
          </small>
        </div>

        <div class="p-field p-col-12 p-md-6">
          <label for="valor">
            Valor <span class="required">*</span>
          </label>
          <p-inputNumber 
            id="valor" 
            formControlName="valor" 
            mode="currency" 
            currency="BRL"
            locale="pt-BR"
            [minFractionDigits]="2"
            [maxFractionDigits]="2"
            [ngClass]="{'invalid-field': lancamentoForm.get('valor')?.invalid && lancamentoForm.get('valor')?.touched}"
            placeholder="0,00">
          </p-inputNumber>
          <small *ngIf="lancamentoForm.get('valor')?.invalid && lancamentoForm.get('valor')?.touched" class="error-message">
            <i class="pi pi-exclamation-triangle"></i>
            Valor é obrigatório e deve ser positivo.
          </small>
          <small class="field-hint">
            <i class="pi pi-info-circle"></i>
            Informe o valor do lançamento
          </small>
        </div>

        <div class="p-field p-col-12">
          <label for="descricao">
            Descrição <span class="required">*</span>
          </label>
          <input 
            pInputText 
            id="descricao" 
            formControlName="descricao"
            [ngClass]="{'invalid-field': lancamentoForm.get('descricao')?.invalid && lancamentoForm.get('descricao')?.touched}"
            placeholder="Descreva o lançamento">
          <small *ngIf="lancamentoForm.get('descricao')?.invalid && lancamentoForm.get('descricao')?.touched" class="error-message">
            <i class="pi pi-exclamation-triangle"></i>
            Descrição é obrigatória.
          </small>
          <small class="field-hint">
            <i class="pi pi-info-circle"></i>
            Descreva detalhadamente o lançamento
          </small>
        </div>

        <div class="p-field p-col-12">
          <label for="contaContabilId">
            Conta Contábil <span class="required">*</span>
          </label>
          <p-dropdown 
            [options]="contaContabilOptions" 
            formControlName="contaContabilId" 
            optionLabel="descricao"
            [ngClass]="{'invalid-field': lancamentoForm.get('contaContabilId')?.invalid && lancamentoForm.get('contaContabilId')?.touched}"
            placeholder="Selecione uma Conta Contábil">
          </p-dropdown>
          <small *ngIf="lancamentoForm.get('contaContabilId')?.invalid && lancamentoForm.get('contaContabilId')?.touched" class="error-message">
            <i class="pi pi-exclamation-triangle"></i>
            Conta Contábil é obrigatória.
          </small>
          <small class="field-hint">
            <i class="pi pi-info-circle"></i>
            Selecione a conta contábil relacionada
          </small>
        </div>
      </div>
    </fieldset>

    <div class="form-actions">
      <p-button type="button" label="Voltar" icon="pi pi-arrow-left" severity="secondary" (click)="prevStep()"></p-button>
      <p-button type="submit" label="Salvar" icon="pi pi-check" [disabled]="lancamentoForm.invalid" class="p-button-primary"></p-button>
    </div>
  </div>
</form>
